// ANGULAR DEPENDANCY
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// SERVICES
import { ApiConfigService } from '../../core/services/api-config/api-config.service';
import { BaseService } from '../../core/services/base/base.service';
import { TokenStorageService } from '../../core/services/token-storage/token-storage.service';

/**
 * This service is for get global and shared master data
 * For get global variables
 *
 * @author Pratik Shihora <pratik@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 16/03/2020 (Pratik Shihora <pratik@saeculumsolutions.com>) initially created global service
 */
@Injectable()
export class GlobalService extends BaseService {

  constructor(
    protected httpClient: HttpClient,
    protected tokenStorage: TokenStorageService,
    public apiConfig: ApiConfigService) {
    super(httpClient, tokenStorage);
  }

}
